import React, { useRef, useState } from 'react'
import Slider from 'react-slick'

import { HTJCat1, HTJCat2, HTJCat3, HTJSlideLeft, HTJSlideRight } from '../../../../assets/svgs/landingV2/business'
import { HTJSh1, HTJSh2, HTJSh3, HTJSh4, HTJSh5, HTJSh6 } from '../../../../assets/images/landingV2/business'
import './styles.scss'
import './responsiveStyles.scss'

function HowToJoin() {
  const slickSettings = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerPadding: '1000px',
    afterChange: (current) => handleArrows(current),
  }

  const slider = useRef(null)
  const [nextDisabled, setNextDisabled] = useState(false)
  const [prevDisabled, setPrevDisabled] = useState(true)

  const handleArrows = (currentSlide) => {
    if (currentSlide == slider.current.props.children.length - 1) {
      setNextDisabled(true)
    } else if (currentSlide == 0) {
      setPrevDisabled(true)
    } else {
      setNextDisabled(false)
      setPrevDisabled(false)
    }
  }

  const nextSlide = () => {
    if (nextDisabled) return

    slider.current.slickNext()
  }

  const prevSlide = () => {
    if (prevDisabled) return

    slider.current.slickPrev()
  }

  return (
    <div id='howtojoin' className='bl_htj'>
      <div className='bl_htj__wrapper'>
        <div className='bl_htj__title'>
          <h1>Як долучитись?</h1>
        </div>
        <div className='bl_htj__info'>
          <div className='bl_htj__info_item'>
            <div className='bl_htj__info_item_logo'>
              <img src={HTJCat1} alt='Cat 1' />
            </div>
            <div className='bl_htj__info_item_title'>
              <h5>01/</h5>
              <h6>Зареєструйтесь</h6>
            </div>
            <div className='bl_htj__info_item_desc'>
              <p>Реєструйтесь на сайті pinka.coffee/business любим зручним для Вас способом.</p>
            </div>
          </div>
          <div className='bl_htj__info_item'>
            <div className='bl_htj__info_item_logo'>
              <img src={HTJCat2} alt='Cat 2' />
            </div>
            <div className='bl_htj__info_item_title'>
              <h5>02/</h5>
              <h6>Активуйте кавʼярню</h6>
            </div>
            <div className='bl_htj__info_item_desc'>
              <p>Підготуйте вашу кав&apos;ярню до роботи, налаштуйте платіжну систему. </p>
            </div>
          </div>
          <div className='bl_htj__info_item'>
            <div className='bl_htj__info_item_logo'>
              <img src={HTJCat3} alt='Cat 3' />
            </div>
            <div className='bl_htj__info_item_title'>
              <h5>03/</h5>
              <h6>Насолоджуйтесь</h6>
            </div>
            <div className='bl_htj__info_item_desc'>
              <p>Переглядайте всю інформацію в одному місці і спостерігайте, як розвивається Ваша кав&apos;ярня!</p>
            </div>
          </div>
        </div>
        <div className='bl_htj__instructions'>
          <p>Щоб зробити процес активації якомога простішим, ми підготували детальну інcтрукцію:</p>
          <div className='bl_htj__instructions_arrows_mobile'>
            <span
              onClick={prevSlide}
              className={`bl_htj__instructions_arrow_mobile ${prevDisabled && 'bl_htj__instructions_arrow-dis'}`}
            >
              <img src={HTJSlideLeft} alt='Arrow left' />
            </span>

            <span
              onClick={nextSlide}
              className={`bl_htj__instructions_arrow_mobile ${nextDisabled && 'bl_htj__instructions_arrow-dis'}`}
            >
              <img src={HTJSlideRight} alt='Arrow right' />
            </span>
          </div>
          <div className='bl_htj__instructions_wrapper'>
            <span
              onClick={prevSlide}
              className={`bl_htj__instructions_arrow ${prevDisabled && 'bl_htj__instructions_arrow-dis'}`}
            >
              <img src={HTJSlideLeft} alt='Arrow left' />
            </span>

            <div className='bl_htj__instructions_slider'>
              <Slider {...slickSettings} ref={slider}>
                <div className='bl_htj__instructions_item'>
                  <div className='bl_htj__instructions_item_image'>
                    <img src={HTJSh1} alt='Slide 1' />
                  </div>
                  <h3>Додайте кавʼярню</h3>
                </div>
                <div className='bl_htj__instructions_item'>
                  <div className='bl_htj__instructions_item_image'>
                    <img src={HTJSh2} alt='Slide 2' />
                  </div>
                  <h3>Додайте/iмпортуйте меню</h3>
                </div>
                <div className='bl_htj__instructions_item'>
                  <div className='bl_htj__instructions_item_image'>
                    <img src={HTJSh3} alt='Slide 3' />
                  </div>
                  <h3>Створiть облiковi данi баристи</h3>
                </div>
                <div className='bl_htj__instructions_item'>
                  <div className='bl_htj__instructions_item_image'>
                    <img src={HTJSh4} alt='Slide 4' />
                  </div>
                  <h3>Заповнiть форму для платiжноi системи LiqPay</h3>
                </div>
                <div className='bl_htj__instructions_item'>
                  <div className='bl_htj__instructions_item_image'>
                    <img src={HTJSh5} alt='Slide 5' />
                  </div>
                  <h3>Зайдiть в особистий кабiнет LiqPay та активуйте мерчант</h3>
                </div>
                <div className='bl_htj__instructions_item'>
                  <div className='bl_htj__instructions_item_image'>
                    <img src={HTJSh6} alt='Slide 6' />
                  </div>
                  <h3>Встановiть застосунок Pinka Barista i зайдiть з облiковими даними баристи</h3>
                </div>
              </Slider>
            </div>

            <span
              onClick={nextSlide}
              className={`bl_htj__instructions_arrow ${nextDisabled && 'bl_htj__instructions_arrow-dis'}`}
            >
              <img src={HTJSlideRight} alt='Arrow right' />
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HowToJoin
